import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { SpeechModelComponent } from 'src/app/views/my-space/global-settings/speech-model.component';
import { Command } from '../../services/dynamic-overlay/dynamic-overlay.service';
import { FeatureFlagService } from '../../services/feature-flag.service';

export type CommandType = 'start' | 'cancel';

@Component({
  selector: 'app-transcription-options',
  imports: [MatButtonModule, SpeechModelComponent, TranslateModule],
  template: `
    <div class="custom-context-menu-wrapper d-flex flex-column gap-2 mb-1 p-2 pt-3">
      <app-speech-model />
      <button mat-flat-button (click)="sendCommand('start')">
        {{ 'TranscriptionOptions.Command.Start' | translate }}
      </button>
    </div>
  `,
})
export class TranscriptionOptionsComponent implements OnInit {
  @Output() commandSelected = new EventEmitter<Command>();
  private featureFlagService = inject(FeatureFlagService);

  ngOnInit(): void {
    if (this.featureFlagService.isFeatureEnabled('bypassTranscriptionModelSelection')) {
      this.sendCommand('start');
    }
  }

  sendCommand(type: CommandType): void {
    const output: Command = {
      type: type,
      data: {},
    };
    this.commandSelected.emit(output);
  }
}
